import { render } from "./multipleChoices.vue?vue&type=template&id=dccff416&scoped=true"
import script from "./multipleChoices.vue?vue&type=script&lang=js"
export * from "./multipleChoices.vue?vue&type=script&lang=js"

import "./multipleChoices.vue?vue&type=style&index=0&id=dccff416&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dccff416"]])

export default __exports__